export const LOAD_PRODUCTS = 'inventory/LOAD_PRODUCTS';
export const LOAD_PRODUCTS_SUCCESS = 'inventory/LOAD_PRODUCTS_SUCCESS';
export const LOAD_PRODUCTS_ERROR = 'inventory/LOAD_PRODUCTS_ERROR';
